// @ts-nocheck
import { populate } from 'populate';
import type { Container, NineSlicePlane } from 'pixi.js';
import { ButtonLargeLayout } from '../../common/buttons/ButtonLargeLayout';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None',
      },
      parent: '',
      data: {
        tapSound: 'UI_Button_Click'
      },
      stateByName: {},
    },
    {
      id: '14f61813-2c69-414d-85f5-95157dec8dae',
      type: 'NineSlicePlane',
      runtimeType: null,
      name: 'shadow',
      className: '',
      x: 0,
      y: 4,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 105,
        y: 37,
      },
      width: 210,
      height: 74,
      leftWidth: 70,
      topHeight: 70,
      rightWidth: 70,
      bottomHeight: 70,
      angle: 0,
      alpha: 0.1,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Button_Background',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {},
    },
    {
      id: '6fcb315d-38d2-47d5-b541-22e879244f02',
      type: 'Layout',
      runtimeType: null,
      name: 'button',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      x: 0,
      y: 0,
      scale: {
        x: 0.6,
        y: 0.6,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        color: 'yellow',
      },
      stateByName: {},
    },
    {
      id: 'fc5d7505-059b-446c-9769-818ffe44a740',
      type: 'Text',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'FREE',
      localize: true,
      maxWidth: 130,
      maxHeight: 91,
      maxFontSize: 0,
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#aa1400',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {},
    },
    {
      id: 'e29274e8-b986-4370-b8e9-15b5961baf01',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: -97,
      y: -31,
      anchor: {
        x: 0,
        y: 0,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 0.6,
        y: 0.6,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Button_Corner_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {},
    },
    {
      id: 'd39d5832-0920-477a-878d-e810ff834564',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: -83,
      y: -23,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 0.75,
        y: 0.75,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Wtach_Ad_Orange_Icon',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {},
    },
  ],
  version: '1.0.0',
  stateNames: [],
  animations: [],
} as const;

export class DailyAdButtonLayout {
  static raw = raw;
  root: Container;
  shadow: NineSlicePlane;
  button: ButtonLargeLayout & { data: (typeof raw)['list'][2]['data'] };

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: (typeof raw)['list'][0];
      shadow: (typeof raw)['list'][1];
      button: (typeof raw)['list'][2];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
